import { render, staticRenderFns } from "./E5684.vue?vue&type=template&id=4689a622&scoped=true"
import script from "./E5684.vue?vue&type=script&lang=js"
export * from "./E5684.vue?vue&type=script&lang=js"
import style0 from "./E5684.vue?vue&type=style&index=0&id=4689a622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4689a622",
  null
  
)

export default component.exports